/**
 * This will create a new cache instance for the given flags.
 *
 * This operation will always create a new cache. If you want to transparently reuse cache instances, use
 * {@link toCache} instead.
 *
 * See {@link Cache} from more information about using caches.
 *
 * @see {@link Cache}
 * @see {@link toCache}
 */
export function createCache(flags) {
    return new CacheInstance(flags);
}
/**
 * Returns a cache instance for the given flags.
 *
 * If the given flags are a cache instance, the cache instance will be returned. Otherwise a new cache instance will
 * be created using {@link createCache}.
 *
 * See {@link Cache} from more information about using caches.
 *
 * @see {@link Cache}
 * @see {@link createCache}
 */
export function toCache(flags) {
    return CacheInstance.from(flags);
}
/** @internal */
export class CacheInstance {
    constructor(flags) {
        this.toCharSet = new WeakMap();
        this.toUnicodeSet = new WeakMap();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.getFirstConsumedCharLTR = new WeakMap();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.getFirstConsumedCharRTL = new WeakMap();
        this.getLongestPrefix = new Map();
        this.dotAll = !!flags.dotAll;
        this.global = !!flags.global;
        this.hasIndices = !!flags.hasIndices;
        this.ignoreCase = !!flags.ignoreCase;
        this.multiline = !!flags.multiline;
        this.sticky = !!flags.sticky;
        this.unicode = !!flags.unicode;
        this.unicodeSets = !!flags.unicodeSets;
    }
    static from(flags) {
        if (flags instanceof CacheInstance) {
            return flags;
        }
        else {
            return new CacheInstance(flags);
        }
    }
}
